import { Injectable } from '@angular/core';
import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

import { GlobalService } from '@app/shared/services/global/global.service';
import { LocalStorageService } from '@app/shared/services/local-storage/local-storage.service';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RoleAuthGuard implements CanActivateChild {
  availableRoutes: any;
  UserRolesList: any;
  constructor(
    private localStorageService: LocalStorageService,
    private _GlobalService: GlobalService,
    private router: Router
  ) {

    const userInfo=this.localStorageService.getLocalStorageItem('response')
    this.UserRolesList= userInfo.data.user.roles;
    console.log("all user roles:",this.UserRolesList)
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const requiredPermission = next.data.permission;
    const requiredRole = next.data.role;
    const breadcrumb = next.data.breadcrumb;
    const type_id = next.data.type_id;

    console.log("next type_id::", type_id);
    console.log("next requiredPermission::", next, requiredPermission);
    console.log("next requiredRole::", requiredRole);
    console.log("state breadcrumb::", breadcrumb,);
    console.log("state UserRolesList::", this.UserRolesList,);

    // If no permission or role required, allow access
    if (!type_id && !requiredRole) {
      console.log('No permission or role required, allowing access');
      return true;
    }
    // if (type_id == 1) {
    //   return true;
    // }

    //this.loadAvailableRoutes();
    // const fun = this.loadPermission(requiredPermission, requiredRole, breadcrumb)
    // console.log("state fun::", fun,);
    // fun.subscribe(value => {
    //   console.log('Value:', value); // Prints: Value: true
    //   return value
    // });
    // ✅ CORRECT: Return the Observable directly
    return this.loadPermission(type_id, requiredRole, breadcrumb).pipe(
      tap(value => console.log('Access granted?', value))
    );
    //return false;
  }
  private loadPermission(type_id, requiredRole, breadcrumb): Observable<boolean> {
    // Get current user from localStorage
    const userStr = this.localStorageService.getLocalStorageItem("response");
    console.log('dummyData:', userStr);
    if (!userStr) {
      console.error('No user found in localStorage, redirecting to login');
      this.router.navigate(['/login']);
      return of(false);
    }
    try {
      // const usr = JSON.parse(userStr);
      console.log(' user:', { userStr, });
      const typeID = userStr.data.type_id;
      const userRoles = userStr.data.user.roles;
      console.log('Current user:', { typeID, userRoles });
      // Check role-based access first (if route specifies a required role)
      if (userRoles) {

        const hasRoleAccess = this.checkRoleAccess(userRoles, requiredRole);
        if (hasRoleAccess) {
          console.log(`User role '${userRoles}' matches required role '${requiredRole}', allowing access`);
          return of(true);
        } else {
          console.log(`User role '${userRoles}' doesn't match required role '${requiredRole}', denying access`);
          this.router.navigate(['/dashboard']);
          return of(false);
        }
      }

      // Check permission-based access
      if (typeID) {
        // return this.checkPermissionAccess(roleId, typeID)
      }

      return of(true);
    }
    catch (error) {
    }
    finally {
      // Optional: Always executes (cleanup code)
      console.log('Cleanup operations');
      //  return of(true);
    }


  }


  /**
   * Check if user has the required role
   */
  private checkRoleAccess(userRole: string | string[], requiredTypeId: string | string[]): boolean {
    if (Array.isArray(requiredTypeId)) {
      return requiredTypeId.includes(userRole[0] || userRole[1]);
    }
    return userRole === requiredTypeId;
  }


  /**
   * Check if user has the required permission via API call
   */
  private checkPermissionAccess(roleId: any, requiredPermission: string): Observable<boolean> {
    return this.loadAvailableRoutes(roleId).pipe(
      map((permissions: any) => {
        const hasPermission = permissions.includes(requiredPermission);

        if (hasPermission) {
          console.log(`User has required permission: ${requiredPermission}`);
          return true;
        } else {
          console.log(`User lacks required permission: ${requiredPermission}`);
          console.log('Available permissions:', permissions);
          this.router.navigate(['/unauthorized']);
          return false;
        }
      }),
      catchError((error) => {
        console.error('Error checking permissions:', error);
        this.router.navigate(['/error']);
        return of(false);
      })
    );
  }


  /**
    * Load available routes/permissions for the user's role
    */
  private loadAvailableRoutes(roleId: number): Observable<string[]> {
    // return this.globalService.getRoleListRoutes(roleId).pipe(
    //   map((res: any) => {
    //     if (res && res.data) {
    //       // Store permissions in global service for reuse
    //       this.globalService.setPermission(res.data);
    //       return res.data;
    //     }
    //     console.warn('No permissions data received from API');
    //     return [];
    //   }),
    //   catchError((error) => {
    //     console.error('Error loading available routes:', error);
    //     return of([]);
    //   })
    // );
    return;
  }

  // getUserRole(): string {
  //   return this.user.role;
  // }

  //disable the routes in side nav according to role
  hasRole(allowedRoles: string[] = []): boolean {
    if (!Array.isArray(this.UserRolesList) || !this.UserRolesList.length) {
      console.warn('UserRolesList empty or undefined');
      return false;
    }

    if (!Array.isArray(allowedRoles) || !allowedRoles.length) {
      console.warn('allowedRoles empty or undefined');
      return false;
    }

    return this.UserRolesList.some(role => allowedRoles.includes(role));
  }


}


